/**
 * SearchCache provides a shared cache instance for SearchAPI.
 * All components using SearchAPI will access the same cache data.
 * This avoids multiple cache instances and ensures consistent search results.
 * Usage:
 *   import { sharedSearchCache } from './SearchCache';
 *   // Use sharedSearchCache in SearchAPI or other modules
 */
export class SearchCache {
    cache: any[] = [];
    cachePosition = 0;
    cacheSize = 0;
    total = 0;
    lastParameters?: Record<string, any>;
    lastApiEndPoint?: string;
    prefetchPromise?: Promise<void>;
    prefetchFrom?: number;
    prefetchTo?: number;
    isPrefetching = false;
    abortController?: AbortController;

    clear() {
        this.cache = [];
        this.cachePosition = 0;
        this.cacheSize = 0;
        this.total = 0;
        this.lastParameters = undefined;
        this.lastApiEndPoint = undefined;
        this.prefetchPromise = undefined;
        this.prefetchFrom = undefined;
        this.prefetchTo = undefined;
        this.isPrefetching = false;
        this.abortController = undefined;
    }
}

export const sharedSearchCache = new SearchCache();